import { useEffect } from 'react';
import { useFeatures } from 'utils/features';
import { useMessage } from 'components/ui';

export const useNeitherDamagesFlagAlert = () => {
  const message = useMessage();
  const { features, loading } = useFeatures();
  const { HORIZON_DAMAGES, LEGACY_DAMAGES } = features;

  useEffect(() => {
    if (!loading && !HORIZON_DAMAGES && !LEGACY_DAMAGES) {
      message.error('Sorry, your account is in a bad state. Please contact support.');
    }
  }, [HORIZON_DAMAGES, LEGACY_DAMAGES, loading, message]);
};
